document.addEventListener('DOMContentLoaded', function () {
  var galleries = document.querySelectorAll('[data-guide-gallery]');
  if (!galleries.length || typeof Swiper === 'undefined') return;

  galleries.forEach(function (gallery) {
    var sectionId = gallery.getAttribute('data-section-id');
    var mainEl = gallery.querySelector('[data-guide-gallery-main]');
    var thumbsEl = gallery.querySelector('[data-guide-gallery-thumbs]');
    var prevEl = gallery.querySelector('[data-guide-gallery-prev]');
    var nextEl = gallery.querySelector('[data-guide-gallery-next]');

    if (!mainEl || !thumbsEl) return;

    var thumbs = new Swiper(thumbsEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      freeMode: true,
      breakpoints: {
        768: {
          spaceBetween: 10
        }
      }
    });

    var main = new Swiper(mainEl, {
      slidesPerView: 1,
      speed: 500,
      loop: false,
      watchOverflow: true,
      thumbs: {
        swiper: thumbs
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide'
      }
    });

    document.addEventListener('shopify:block:select', function (event) {
      var block = event.target.closest('.swiper-slide');
      if (!block) return;
      var wrapper = block.closest('[data-guide-gallery]');
      if (!wrapper || wrapper.getAttribute('data-section-id') !== sectionId) return;
      var index = Number(block.getAttribute('data-swiper-slide-index'));
      if (!Number.isNaN(index)) main.slideTo(index);
    });
  });
});
